__turbopack_context__.v({
  "heartbeat": "FeedbackEditor-module-scss-module__xHqo2a__heartbeat",
  "root": "FeedbackEditor-module-scss-module__xHqo2a__root",
});
